import { useState } from 'react';
import { Logo } from '../components/Logo';
import { useAuth } from '../lib/auth';

export function PendingApproval() {
  const { profile, signOut } = useAuth();
  const inReview = profile?.status === 'verification_pending';
  // "Check status" used to be <Link to="/">, and this screen IS "/", so React Router
  // matched the same route and did nothing at all. Re-read from the server instead,
  // and always say something back so the tap never feels dead.
  const [checking, setChecking] = useState(false);
  const [noChange, setNoChange] = useState(false);

  const check = () => {
    setChecking(true);
    setNoChange(false);
    // The profile is live via onSnapshot, so an approval lands on its own; this is
    // for the pilot who wants to poke it. Give it a beat, then reload for certainty.
    window.setTimeout(() => window.location.reload(), 600);
    // If the reload is blocked or slow, the pilot still gets an answer.
    window.setTimeout(() => {
      setChecking(false);
      setNoChange(true);
    }, 3000);
  };

  const name = profile?.personal?.firstName ? `, ${profile.personal.firstName}` : '';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-sky-50 p-6">
      <div className="card max-w-lg w-full p-8 text-center">
        <Logo className="text-xl" />
        <h1 className="mt-6 text-2xl font-display font-bold text-navy-900">
          {inReview ? 'Application in review' : 'Account pending approval'}
        </h1>
        <p className="mt-2 text-ink-muted">
          {inReview
            ? `Thanks${name}. Your profile and documents are in. The owner is reviewing them and will email you as soon as you’re approved. Your lease comes next — booking opens once it’s signed and back on file.`
            : `Thanks${name}. Your registration has been received. The owner will review your account and email you when you’re approved to continue.`}
        </p>

        {noChange && (
          <p className="mt-4 text-sm text-ink-muted">
            No change yet — you’re still in review. We’ll email you the moment that changes,
            so there’s nothing you need to watch.
          </p>
        )}

        <div className="mt-6 flex flex-col sm:flex-row gap-2 justify-center">
          <button onClick={signOut} className="btn-secondary">
            Sign out
          </button>
          <button onClick={check} disabled={checking} className="btn-ghost">
            {checking ? 'Checking…' : 'Check status'}
          </button>
        </div>
      </div>
    </div>
  );
}
